import React from 'react';

import { Box, Button, Dialog, Text } from '@betterment/samba-react';

import FormButton from './FormButton';

const modalText =
  'I acknowledge that by proceeding I am being granted access to my client’s account and any actions taken are a direct result of my client’s explicit instructions.';

export const ImpersonationModal: React.FC<{ isOpen: boolean; closeModal: () => void; linkUrl?: string }> = ({
  isOpen,
  closeModal,
  linkUrl,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={open => !open && closeModal()}>
      <Dialog.Content size="large" css={{ p: 'space.400' }}>
        <Dialog.Title>Confirm Log In</Dialog.Title>
        <Dialog.Description asChild={true}>
          <Text as="p" css={{ marginBottom: 'space.200', _last: { marginBottom: 'space.0' } }}>
            {modalText}
          </Text>
        </Dialog.Description>
        <Box css={{ display: 'flex', mt: 'space.400', gap: 'space.200' }}>
          <FormButton
            onClick={() => closeModal()}
            method="post"
            action={linkUrl || '#'}
            shouldOpenNewTab={true}
            autoFocus={true}
          >
            Log in
          </FormButton>
          <Button variant="solidSecondary" onClick={() => closeModal()}>
            Cancel
          </Button>
        </Box>
      </Dialog.Content>
    </Dialog>
  );
};
